import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { storeSettingsListenerSaga } from './store-settings';
import { syncSettingsListenerSaga } from './sync-settings';

export function* rootSaga(): SagaIterator {
    yield all([fork(storeSettingsListenerSaga), fork(syncSettingsListenerSaga)]);
}
